export const columnasGeneradorContrasenas = [
  {
    label: "Contraseña",
    field: "password",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
];
